import React, { useEffect, useState } from "react";
import infoIcon from "../../../../assets/images/Icons/info_icon.svg";
import {
  makeAjax,
  showMessage,
  respStatus,
  url,
  matchValidateVersi,
} from "../../../../helpers/global_helper";
import BetFiftyFiftySuccessPopup from "../../../Popups/BetFiftyFiftySuccessPopup";
import ConfirmBetDeskonPopup from "../../../Popups/ConfirmBetDeskonPopup";
import { useSelector, useDispatch } from "react-redux";
import CancelledBetDeskonPopup from "../../../Popups/CancelledBetDeskonPopup";
import { withTranslation } from "react-i18next";
import { formatPricewithdecimal, formatPrice } from "../../../NumberFormat";
import ErrorInnerPopup from "../../../Popups/ErrorInnerPopup";
import ErrorPopup from "../../../Popups/ErrorPopup";
import { getUserBalance, setCommonConfig } from "../../../../redux/actions";
import GameClosedPopup from "../GameClosedPopup";
import MarketClose from "../MarketClose";

const FiftyFifty2DVersiWap = (props) => {
  const dispatch = useDispatch();
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const gameType = useSelector((state) => state.CommonConfig.gameType);
  const user_balance = useSelector((state) => state.UserBalance.user_balance);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);

  const initialReqData = {
    gameId: gameId,
    gameType: "50502d",
    fastbet: true,
    databet: "",
    allowPartner: "allowPartner",
    multiple:betDiscount.showMultiple
  };

  const sendInitialData = {
    gameId: gameId,
    gameType: "50502d",
    betTogelAuth: "betTogelAuth",
    allowPartner: null,
    dataangka: [],
  };
  const [errMessage, setErrorMessage] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [betPopupValue, setBetPopupValue] = useState([]);
  const [data, setData] = useState({});
  const [showTooltip, setShowTooltip] = useState(false);
  const [finalRespData, setFinalRespData] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [angka, setAngka] = useState([]);
  const [reqData, setReqData] = useState(initialReqData);
  const [showCancelledPopup, setShowCancelledPopup] = useState(false);
  const [totalValueClick, setTotalValueClick] = useState(false);
  const [totalCountClick, setTotalCountClick] = useState(false);
  const [sentData, setSentData] = useState(sendInitialData);
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);

  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  const handleChange = (e) => {
    setTotalValueClick(false);
    const { name, value } = e.target;
    setReqData({
      ...reqData,
      [name]: value,
    });
  };

  useEffect(() => {
    handleResetBtn();
  }, [gameId]);

  const handleResetBtn = () => {
    setTotalCountClick(false);
    setReqData(initialReqData);
    setSentData(sendInitialData);
    setData({});
  };
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }

  };
  const handleSubmitBtn = () => {
    if (!totalValueClick) {
      if (!reqData.databet) {
        setErrorMessage(props.t("format_input"));
        setShowErrorPopup(true);
        return;
      }
      let matchValidate = matchValidateVersi(gameType, reqData);
      if (matchValidate) {
        setErrorMessage(props.t(matchValidate));
        setShowErrorPopup(true);
        return;
      }
    }
    makeAjax(url.TOGEL_API.processDataBet, reqData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }
        if (response.code !== "validation_error") {
          setReqData(initialReqData);
          response.code
            ? setErrorMessage(props.t(response.code))
            : setErrorMessage(props.t("guess_bet_wrong"));
          setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      setTotalValueClick(true);
      setData(response.data);
      setReqData(initialReqData);
      setShowConfirmationPopup(true);
      let newAngaka = [];
      response.data.dataangka.forEach((item) => {
        const angaka = [item.nomor, item.taruhan, item.status];
        newAngaka.push(angaka);
      });
      const newBet = response.data.dataangka.map((item) => item.nomor);
      setBetPopupValue(newBet);
      setAngka(newAngaka);
    });
  };

  useEffect(() => {
    setSentData({
      ...sentData,
      gameId: gameId,
      dataangka: angka,
    });
  }, [angka]);

  const handleOnCancelBet = () => {
    setShowCancelledPopup(true);
    setShowConfirmationPopup(false);
  };

  const submitProcessOk = () => {
    if (data.pay > user_balance.coin) {
      setErrorMessage(props.t("insufficient_balance"));
      setShowErrorPopup(true);
      setShowConfirmationPopup(false);
    } else {
      setShowConfirmationPopup(false);
      makeAjax(url.TOGEL_API.process5050Shio, sentData).then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
          if (response.code !== "validation_error") {
            response.code
              ? setErrorMessage(props.t(response.code))
              : setErrorMessage(props.t("guess_bet_wrong"));
            setShowErrorPopup(true);
            return;
          }
          showMessage("server error No data find", "error", "error");
          return;
        }
        setFinalRespData((prevArray) => [...prevArray, response.data]);
        dispatch(getUserBalance());
        setSuccessPopup(true);
        handleResetBtn();
      });
    }
  };

  const handlePopupClose = () => {
    setData({});
    setFinalRespData([]);
    setSuccessPopup(false);
    setTotalValueClick(false);
    handleResetBtn();
    setBetPopupValue([]);
  };

  const handleTotalValueCheck = () => {
    if (!reqData.databet) {
      setErrorMessage(props.t("format_input"));
      setShowErrorPopup(true);
      return;
    }
    let matchValidate = matchValidateVersi(gameType, reqData);
    if (matchValidate) {
      setErrorMessage(props.t(matchValidate));
      setShowErrorPopup(true);
      return;
    }

    makeAjax(url.TOGEL_API.processDataBet, reqData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowConfirmationPopup(false);
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          return;
        }
        if (response.code === "market_close_err") {
          setShowConfirmationPopup(false);
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          return;
        }
        if (response.code !== "validation_error") {
          setReqData(initialReqData);
          response.code
            ? setErrorMessage(props.t(response.code))
            : setErrorMessage(props.t("guess_bet_wrong"));
          setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      setTotalValueClick(true);
      setData(response.data);
      setTotalCountClick(true);

      let newAngaka = [];
      response.data.dataangka.forEach((item) => {
        const angaka = [item.nomor, item.taruhan, item.status];
        newAngaka.push(angaka);
      });
      const newBet = response.data.dataangka.map((item) => item.nomor);
      setBetPopupValue(newBet);
      setAngka(newAngaka);
    });
  };

  const handleTotalValueCheckOk = () => {
    if (totalCountClick) {
      setShowConfirmationPopup(true);
    }
  };

  return (
    <div className="versiwrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          {/* --- Rules ---  */}
          <div className="rules_container">
            <div>
              <p>{props.t('50502D_text')}</p>
              <p>
                Format Tarun: Pilihan1*Pilihan2#10+Pilihan3*
                Pilihan4#10+Pilihan4*Pilihan5#1
              </p>
              <p>Conoth Penulisan: b*k#1+gj*gn#2</p>
              <p>Keteramgan: b(besar),k(kecil),gj(ghjil),gn(genap)</p>
            </div>
            <div className="rules_conversion">
              <p>
                Konversi <br /> 1 = {betDiscount.showMultiple}
              </p>
            </div>
          </div>
          {/* --- Rules ---  */}
          <div className="versicontainer">
            <textarea
              rows="20"
              placeholder="b*k#1+gj*gn#2"
              name="databet"
              value={reqData.databet}
              onChange={handleChange}
            ></textarea>
          </div>
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="result_left">
                <p>
                  <span>Total {props.t("line")}</span> :{" "}
                  {data.line ? data.line : "-"}
                </p>
                <p>
                  <span>Total {props.t("purchases")}</span> :{" "}
                  {data.tover ? formatPrice(data.tover) : "-"} &nbsp;
                </p>
              </div>
              <div className="result_right">
                <p>
                  <span>
                    {props.t("total")} {props.t("discount")}
                  </span>
                  : {data.disc ? formatPrice(data.disc) : "-"}
                </p>
                <p>
                  <span>Total {props.t("payment")}</span> :{" "}
                  {data.pay ? formatPrice(data.pay) : "-"}
                </p>
              </div>
              <div className="info_icon">
                <img src={infoIcon} alt="" onClick={toggleTooltip} />
                {showTooltip && (
                  <div
                    className="info_icon_overlay"
                    onClick={() => setShowTooltip(false)}
                  ></div>
                )}
                {showTooltip && (
                  <span className="tooltip">
                    <div className="tooltip_wrapper">
                      <span className="tooltip_heading">
                        Contoh Format Taruhan
                      </span>
                      <span className="tooltip_content">b*k#1+gj*gn#2</span>
                    </div>
                  </span>
                )}
              </div>
            </div>
            <div className="versiweb_result_right">
              <p>
                Konversi<br></br> 1 = {betDiscount.showMultiple}
              </p>
            </div>
          </div>

          {/* button*/}
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="button_left">
                <button onClick={handleTotalValueCheck}>
                  {props.t("count_total")}
                </button>
              </div>
              <div className="button_right">
                <button onClick={handleResetBtn}>{props.t('reset')}</button>
              </div>
            </div>
            <div className="versiweb_result_right btn_Submit">
              {totalValueClick ? (
                <button onClick={handleTotalValueCheckOk}>{props.t('submit')}</button>
              ) : (
                <button onClick={handleSubmitBtn}>{props.t('submit')}</button>
              )}
            </div>
          </div>
        </>
      )}

      {successPopup && (
        <div className="popup-overlay ">
          <BetFiftyFiftySuccessPopup
            response={finalRespData}
            betValue={betPopupValue}
            onClose={handlePopupClose}
          />
        </div>
      )}
      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={handleOnCancelBet}
          submitProcessOk={submitProcessOk}
        />
      )}
      {showCancelledPopup && (
        <CancelledBetDeskonPopup onClose={() => setShowCancelledPopup(false)} />
      )}
      {showErrorPopup && (
        <ErrorInnerPopup
          modalTitle={""}
          modalHeader={true}
          onCloseModal={() => setShowErrorPopup(false)}
        >
          <ErrorPopup
            message={errMessage}
            onClose={() => setShowErrorPopup(false)}
          />
        </ErrorInnerPopup>
      )}
    </div>
  );
};

export default withTranslation()(FiftyFifty2DVersiWap);
